/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const RearViewCamera = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 20" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M15.05 8.22a2.66 2.66 0 1 0 2.66 2.66 2.65 2.65 0 0 0-2.66-2.66zm6.75-6.05l-1-1.95H10.07l-1 2H6.15V.52H1.94v1.65H.28v17.61h25.44V2.17H21.8zM4.48 8.61a2.3 2.3 0 0 1-2.24-2.24 2.3 2.3 0 0 1 2.24-2.24 2.3 2.3 0 0 1 2.24 2.24 2.3 2.3 0 0 1-2.24 2.24zM15 17.1a6.13 6.13 0 1 1 6.09-6.1A6.12 6.12 0 0 1 15 17.1z" fillRule="nonzero" />
      </g>
    </svg>
  </span>
);

RearViewCamera.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

RearViewCamera.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default RearViewCamera;
